module.exports = __webpack_public_path__ + "media/14039.e25a9e7d.wav";